import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Container, Center, Image, Title, PinInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button, LayoutPublic, Text } from "components"
import { RouteConstants, ServiceConstants } from "constant";
import { PublicService } from "services";
import { AppUtils } from "utils";

import { IRootState } from "config/redux";

import logo from 'assets/logo.svg';

const { ROUTE_REGISTRATION } = RouteConstants;
const { REQUEST_PENDING, REQUEST_REGISTRATION_VERIFY_CODE } = ServiceConstants;

const RegistrationVerifyCode = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const email = new URLSearchParams(window.location.href.split('?')[1]).get('email');
  const serviceObject = useSelector((state: IRootState) => state.service.object[REQUEST_REGISTRATION_VERIFY_CODE]);
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    AppUtils.resolveServiceObject(serviceObject, REQUEST_REGISTRATION_VERIFY_CODE,
      (val) => navigate(`${ROUTE_REGISTRATION}/passwort-festlegen?email=${email}&identification=${val}`),
      (err) => setError(err.data.message)
    );
  }, [serviceObject])

  const form = useForm({
    initialValues: {
      email: email!,
      code: ''
    },
    validate: {
      email: (value: any) => AppUtils.isEmpty(value) || !AppUtils.isEmailValid(value) ? t('error.required') : null,
      code: (value: any) => AppUtils.isEmpty(value) || value.length !== 6 ? t('error.required') : null,
    }
  });

  const isLoading = useCallback(() => serviceObject && serviceObject.status === REQUEST_PENDING, [serviceObject]);
  const checkCode = useCallback(() => {
    setError(undefined);
    PublicService.registrationVerifyCode(form.getTransformedValues().email, form.getTransformedValues().code);
  }, [form]);

  return (
    <LayoutPublic>
      <Container
          h={'80vh'}
          display={'flex'}
          style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
        >
        <Box mt={"xl"} w={350}>
          <Center>
            <Image src={logo} w={180} fallbackSrc={logo} />
          </Center>
          <Text style={{ fontSize: 24, textAlign: 'center' }}>{'Webkredit.ch'}</Text>
          <Title fw={500} ta={'center'} my={'lg'} mt={40}>{t('registration.verify.title')}</Title>
          <Text style={{ textAlign: 'center' }}>{t('registration.verify.description')}</Text>
          <Center>
            <Box mt={40}>
              <PinInput
                length={6}
                type={'number'}
                size={'md'}
                mask={false}
                placeholder={''}
                {...form.getInputProps('code')}
              />
              {error && <Text c={'var(--mantine-color-error)'} mt={'md'}>{error}</Text>}
            </Box>
          </Center>
          <Box mt={40}>
            <Button
              fullWidth={true}
              disabled={!form.isValid() || isLoading()}
              loading={isLoading()}
              onClick={checkCode}
            >
              {t('action.submit')}
            </Button>
          </Box>
        </Box>
      </Container>
    </LayoutPublic>
  )
}

export default RegistrationVerifyCode;